// extracted by mini-css-extract-plugin
export var active = "join_section-module--active---v+nH";
export var choose_button = "join_section-module--choose_button--r7AWD";
export var conditions = "join_section-module--conditions--+YOL9";
export var conditions_description = "join_section-module--conditions_description--SeePz";
export var conditions_link = "join_section-module--conditions_link--rsNgt";
export var description = "join_section-module--description--AK6dd";
export var form_container = "join_section-module--form_container--1gdt6";
export var join_heading = "join_section-module--join_heading--cgfmC";
export var join_section = "join_section-module--join_section--1K-Jm";
export var join_section_container = "join_section-module--join_section_container--PiO4S";
export var join_wrapper = "join_section-module--join_wrapper--kjroF";
export var registr_form = "join_section-module--registr_form--6oliD";
export var tab_container = "join_section-module--tab_container--o-qxk";
export var tabs_text = "join_section-module--tabs_text--W0tJC";